module.exports = require("image-capture");